import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import '../index.global.scss';
import theme from './theme.scss';
export default _object_spread({}, theme);
